export const ECateRootId = {
  Goods: 1,
  Handmade: 2,
  BrandDeal: 3,
  Ebook: 4,
} as const;

export type ECateRootId = (typeof ECateRootId)[keyof typeof ECateRootId];
